import { useEffect } from "react";
import styles from "../../main/Filters/Filters.module.scss";
import SearchFilter from "../../../SearchFilter/SearchFilter";
import { useActions } from "../../../../hooks/useActions";
import RegistrationDateFilter from "./RegistrationDateFilter/RegistrationDateFilter";
import OtherFilters from "./OtherFilters/OtherFilters";
import RegionDropdown from "../../main/RegionDropdown/RegionDropdown";
import DatasetsDropdown from "../../_mapFilterComponents/DatasetsDropdown/DatasetsDropdown";
import SavedFiltersButton from "../../../templates/SavedFilters/SavedFiltersButton/SavedFiltersButton";
import ClearAllFiltersDesktopButton from "../../../../share/filters/ClearAllFiltersDesktopButton";
import MobileClearAllButton from "../../../../share/filters/MobileClearAllButton";
import AddMoreFiltersButton from "../../../templates/AddSavedFilters/AddMoreFiltersButton";
import { FilterGroup } from "../../../../share/filters";
import CompanySizeFilter from "./CompanySize/CompanySizeFilter";
import ServivesCategoryFilter from "./ServicesCategoryFilter/ServicesCategoryFilter";
import {
  ListViewActions,
  ListViewContainer,
  ListViewFilterGroup,
  ListViewSearchRow,
  ListViewSearchSection,
  ListViewSearchWrapper,
  ListViewTopContainer,
  MapToggleButton,
} from "../../shared/ListViewLayout";
import { breakpoints, icons } from "../../../../constants";
import { UserProfileListControls } from "../../../UserProfileBar/UserProfileBar";
import useMobileScreen from "../../../../hooks/useMobileScreen";

interface FiltersProps {
  isListView?: boolean;
}

const Filters = ({ isListView = false }: FiltersProps) => {
  const { setCleanAllCybersecurityFilters, setIsListViewActive } = useActions();
  const isBelowMedium = useMobileScreen(breakpoints.medium);
  const shouldRenderListView = isListView && !isBelowMedium;

  useEffect(() => {
    setIsListViewActive(true);
  }, [setIsListViewActive]);

  const handleClean = () => {
    setCleanAllCybersecurityFilters();
  };

  const handleShowMap = () => {
    setIsListViewActive(false);
  };

  if (shouldRenderListView) {
    return (
      <ListViewContainer>
        <ListViewTopContainer>
          <div className={styles.regionsDatasetsWrapper}>
            <RegionDropdown />
            <DatasetsDropdown />
          </div>
          <ListViewActions>
            <SavedFiltersButton />
            <AddMoreFiltersButton />
            <UserProfileListControls />
          </ListViewActions>
        </ListViewTopContainer>
        <ListViewSearchSection>
          <ListViewSearchRow>
            <MapToggleButton
              type="button"
              onClick={handleShowMap}
              aria-label="Show map view"
              disabled={!isBelowMedium}
            >
              <img src={icons.NavMapIcon} alt="Show map view" />
            </MapToggleButton>
            <ListViewSearchWrapper>
              <SearchFilter />
            </ListViewSearchWrapper>
            <ListViewFilterGroup onClick={(event) => event.stopPropagation()}>
              <ServivesCategoryFilter />
              <CompanySizeFilter />
              <RegistrationDateFilter />
              <OtherFilters />
              <MobileClearAllButton onClick={handleClean} />
            </ListViewFilterGroup>
          </ListViewSearchRow>
        </ListViewSearchSection>
        <ClearAllFiltersDesktopButton onClick={handleClean} />
      </ListViewContainer>
    );
  }

  return (
    <div className={styles.filterMainWrapper}>
      <div className={styles.topContainer}>
        <div className={styles.regionsDatasetsWrapper}>
          <RegionDropdown />
          <DatasetsDropdown />
        </div>
        {/* <div className={styles.topContainerTitle}>Карта Cybersecurity</div> */}
        <div className={styles.topContainerButtons}>
          <SavedFiltersButton />
          <AddMoreFiltersButton />
        </div>
      </div>
      <div className={styles.searchWrapper}>
        <SearchFilter />
      </div>
      <FilterGroup onClick={(event) => event.stopPropagation()}>
        <ServivesCategoryFilter />
        <CompanySizeFilter />
        <RegistrationDateFilter />
        <OtherFilters />
        <MobileClearAllButton onClick={handleClean} />
      </FilterGroup>

      <ClearAllFiltersDesktopButton onClick={handleClean} />
    </div>
  );
};

export default Filters;
